import React from 'react';
import './Footer.css';
import SocialIcon from '../Social Icon/SocialIcon'
import { BsTwitterX } from "react-icons/bs";
import ContactFixedButton from '../ContactUs Fixed Button/ContactFixedButton';


const Footer = () => {
  return (
    <footer className="footer">
    <ContactFixedButton/>
    <SocialIcon/>
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">WCPL Workmates Pvt. Ltd.</h3>
          <p className="footer-description">
            Building dreams with precision and excellence. Quality construction
            services for residential and commercial projects.
          </p>
          <div className="social-icons-container">
            <div className="social-icons">
              <a href="#" className="social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="social-icon">
                <i> <BsTwitterX /></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-subtitle">Quick Links</h4>
          <ul className="footer-links">
            <li>
              <a href="/home">Home</a>
            </li>
            <li>
              <a href="/aboutus">About Us</a>
            </li>
            <li>
              <a href="#">Projects</a>
            </li>
            <li>
              <a href="#">Key Offering</a>
            </li>
            <li>
              <a href="/contactus">Contact</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-subtitle">Services</h4>
          <ul className="footer-links">
            <li>
              <a href="#">Residential Construction</a>
            </li>
            <li>
              <a href="#">Commercial Buildings</a>
            </li>
            <li>
              <a href="#">Renovation</a>
            </li>
            <li>
              <a href="#">Architectural Design</a>
            </li>
            <li>
              <a href="#">Project Management</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-subtitle">Contact Us</h4>
          <div className="contact-info-footer">
            <p>
              <i className="fas fa-map-marker-alt"></i> Office No. B-9, 2nd Floor, Pozone Trade Center, API Corner, Chikalthana, Chhatrapati Sambhajinagar
            </p>
            <p>
              <i className="fas fa-phone"></i>Landline No: +91 8766527422
            </p>
            <p>
              <i className="fas fa-phone"></i>Tushar Sir: +91 9049498918
            </p>
            <p>
              <i className="fas fa-envelope"></i> info@workmates.co.in
            </p>
            <p>
              <i className="fas fa-clock"></i> Mon-Sat: 10AM - 6PM
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy;  WCPL Workmates Private Limited. All rights
          reserved. Designed by <a href='https://www.mketech.in/' target='_blank'>MK e-Tech Private Limited</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;